import React, { useEffect, useState } from "react";
import classes from "./CoachInsightsSidebar.module.css";
import Fonts from "../assets/Fonts";
import Colors from "../assets/Colors";
import { coachDemoImg, ArrowUpRightBlue } from "../../constant/imagePath";
import StarRatings from "react-star-ratings";
import { Button } from "../Button/Button";
import { LinkButtonWithIcon } from "../LinkButtonWithIcon/LinkButtonWithIcon";
import PropTypes from "prop-types";

export const CoachInsightsSidebar = ({ data, onClick, customStyle }) => {
  const earnings = [
    { title: "This month", earning: data?.currentEarning },
    { title: "Prev. month", earning: data?.previousMonthEarning },
  ];

  return (
    <div
      style={{
        backgroundColor: Colors.neutralShadesOfWhiteSmoke,
        height: "768px",
        width: "308px",
        ...customStyle,
      }}
      className={classes.sidebarContainer}
    >
      {/* Header */}
      <div className={classes.header}>
        <h6
          style={{
            ...Fonts.h5,
            color: Colors.neutralShadesOfNero,
            paddingRight: "30px",
          }}
        >
          Learn about your income and progress.
        </h6>
      </div>
      {/* Border After Header */}
      <p
        className={classes.borderHalf}
        style={{ borderBottom: `1px solid ${Colors.neutralShadesOfGainsboro}` }}
      ></p>
      {/* Working Duration */}
      <p
        style={{
          ...Fonts.p2,
          color: Colors.neutralShadesOfDimGray,
          marginRight: "57px",
        }}
      >
        You’ve been a coach on Lytesnap for{" "}
        <span style={{ color: Colors.neutralShadesOfNero, ...Fonts.h9 }}>
          32 days.
        </span>{" "}
        Congrats!
      </p>
      {/* Earning Box */}
      <div className={classes.earningBoxContainer}>
        {earnings?.map((item) => {
          return (
            <div className={classes.earningBox}>
              <p style={{ ...Fonts.p2, color: Colors.neutralShadesOfNero }}>
                {item?.title}
              </p>
              <h6 style={{ ...Fonts.h4f26, color: Colors.neutralShadesOfNero }}>
                ${item?.earning}
              </h6>
            </div>
          );
        })}
      </div>
      <p
        style={{
          ...Fonts.p2,
          color: Colors.neutralShadesOfDimGray,
          marginRight: "28px",
        }}
        className={classes.earningPercent}
      >
        Earnings are{" "}
        <span style={{ color: Colors.neutralShadesOfNero, ...Fonts.h9 }}>
          {data?.earningDays}%
        </span>{" "}
        more than last month{" "}
      </p>
      {/* Rating Line */}
      <h5 className={classes.rating}>
        <span
          style={{
            ...Fonts.h5,
            color: Colors.neutralShadesOfNero,
          }}
        >
          You have
        </span>
        <StarRatings
          numberOfStars={1}
          rating={data?.rating / 5}
          starRatedColor={Colors.mainShadeOfRed}
          starDimension={"24px"}
        />
        <span
          style={{
            ...Fonts.h5,
            color: Colors.neutralShadesOfNero,
          }}
        >
          {data?.rating}
        </span>
      </h5>
      {/* Students Reactions */}
      <p
        className={classes.whatStudentSay}
        style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}
      >
        Here’s what your students say:
      </p>
      {/* Tags */}
      <div className={classes.tagsContainer}>
        {data?.studentsSayings?.map((item) => {
          return (
            <span>
              <Button
                label={item}
                customStyle={{
                  ...Fonts.p2,
                  padding: "8px 16px 8px 16px",
                  width: "max-content",
                }}
              />
            </span>
          );
        })}
      </div>
      <div className={classes.readAllReviews}>
        <LinkButtonWithIcon
          text={"Read all reviews"}
          customStyle={{ ...Fonts.b2, lineHeight: "20px" }}
          rightIcon={ArrowUpRightBlue}
          onClick={onClick}
          primary={true}
        />
      </div>
    </div>
  );
};

CoachInsightsSidebar.propTypes = {
  data: PropTypes.object,
  onClick: PropTypes.func,
};

CoachInsightsSidebar.defaultProps = {
  data: {
    currentEarning: "436",
    previousMonthEarning: "260",
    earningDays: 32,
    rating: 4.7,
    studentsSayings: [
      "Friendly to kids",
      "Competitive",
      "Discipline",
      "Caring",
    ],
  },
};
